import React from 'react';
import PropTypes from 'prop-types';
import { getClassName } from 'utils/ui/classes';

const UserIcon = ({ className, size }) => {
  if (size === 'small') {
    return (
      <svg
        className={getClassName(className)}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
          clipRule="evenodd"
        />
      </svg>
    );
  }
  return (
    <svg
      className={getClassName(className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
      />
    </svg>
  );
};

UserIcon.propTypes = {
  size: PropTypes.oneOf(['small', 'medium']),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};

UserIcon.defaultProps = {
  size: 'small',
  className: 'w-5 h-5',
};

export default UserIcon;
